import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchNotificationServiceThreshold = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getNotificationServiceThreshold',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};

export const apiFetchElementTypes = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getThresholdElementTypesDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.get(serviceURL, payload);
};

export const apiDeleteThreshold = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'deactivateThresholdDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      thresholdId: payload.thresholdId,
    },
  });
  return axios.delete(serviceURL);
};

export const apiUpdateThreshold = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'updateThresholdDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.put(serviceURL, payload);
};
